<template>
	<div class="field">
		<label class="label">{{ label }}</label>
		<div class="field">
			<div class="control">
				<input
					class="input"
					type="Number"
					step="any"
					:min="min"
					:class="{ 'is-danger': showError }"
					:placeholder="placeholder"
					:value="myValue"
					@wheel.prevent="onScroll"
					@input="myInput"
					@blur="myBlur"
					@focus="focus"
				/>
			</div>
		</div>
		<p v-if="showError" class="help is-danger">{{ error }}</p>
	</div>
</template>

<script>
import fieldMixin from "@lab/utils/fieldMixin";
export default {
	mixins: [fieldMixin],
	props: {
		placeholder: {
			type: String,
			default: () => null
		},
		label: {
			type: String,
			required: true
		},
		min: {
			type: String,
			default: () => "0"
		},
		icon: {
			type: String,
			default: () => null
		},
		disabled: {
			type: Boolean,
			default: () => false
		}
	},
	computed: {
		hasIcon() {
			return this.icon;
		},
		myValue() {
			if (this.hasChanged) {
				return Number(this.value);
			} else {
				return this.value > 0 ? Number(this.value) : "";
			}
		},
		hasChanged() {
			return this.meta.changed;
		}
	},
	methods: {
		onScroll(e) {
			e.cancelBubble = true;
			// Do nothing
		},
		myBlur() {
			const val = this.myValue;
			this.blur(val);
		},
		myInput(e) {
			this.$store.commit("form_field_change", {
				form: this.form,
				field: this.name,
				value: Number(this.extractValue(e))
			});
		},
		addSuburbs() {
			this.$emit("add-suburbs", this.value);
		}
	}
};
</script>

<style lang="scss" scoped>
// .control.has-icons-left .icon {
// 	color: #4a4a4a;
// }
// input[type="number"] {
// 	-moz-appearance: textfield;
// }
// input::-webkit-outer-spin-button,
// input::-webkit-inner-spin-button {
// 	-webkit-appearance: none;
// }
</style>
